var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',[_c('UserWidget',{staticClass:"user"}),_c('LeftMenu',{staticClass:"left_menu"}),_c('AnalyticsWidget',{staticClass:"stat"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }